document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const headerNav = document.querySelector('[data-header-nav]');
  const siteHeader = document.querySelector('[data-site-header]');

  if (menuToggle && headerNav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = headerNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen);
    });
  }

  if (siteHeader) {
    const onScroll = () => {
      siteHeader.classList.toggle('is-scrolled', window.scrollY > 20);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  initShopPage();
});

function initShopPage() {
  const shopPage = document.querySelector('[data-shop-page]');
  if (!shopPage) return;

  const searchInput = shopPage.querySelector('[data-shop-search]');
  const filters = shopPage.querySelector('[data-shop-filters]');
  const items = shopPage.querySelectorAll('[data-shop-item]');
  const emptyMsg = shopPage.querySelector('[data-shop-empty]');

  let activeFilter = 'all';

  const applyFilters = () => {
    const query = (searchInput?.value || '').trim().toLowerCase();
    let visibleCount = 0;

    items.forEach((item) => {
      const title = item.dataset.productTitle || '';
      const type = item.dataset.productType || '';
      const matchesSearch = !query || title.includes(query);
      const matchesType = activeFilter === 'all' || type === activeFilter;
      const visible = matchesSearch && matchesType;

      item.classList.toggle('is-hidden', !visible);
      if (visible) visibleCount += 1;
    });

    if (emptyMsg) {
      const showEmpty = items.length > 0 && visibleCount === 0;
      emptyMsg.hidden = !showEmpty;
      emptyMsg.classList.toggle('shop-page__empty--hidden', !showEmpty);
    }
  };

  if (searchInput) {
    searchInput.addEventListener('input', applyFilters);
  }

  if (filters) {
    filters.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-filter]');
      if (!btn) return;

      activeFilter = btn.dataset.filter || 'all';
      filters.querySelectorAll('[data-filter]').forEach((el) => {
        el.classList.toggle('is-active', el === btn);
      });
      applyFilters();
    });
  }
}
